import { TreeDto } from "@/helpers/interfaces";

export const getRouteGroupTree = (nodes: TreeDto[], name: string) => {
    return nodes.map(node => {
        if (node.label == name) {
            return node;
        }
    })
}

export const getRouteTree = (nodes: TreeDto[], name: string) => {
    for (const node of nodes) {
        const route = node.children?.find(x => x.label == name);
        if (route) {
            return route;
        }
    }
}

export const getTripPatternTree = (nodes: TreeDto[], name: string) => {
    for (const node of nodes) {
        if (node.children) {
            for (const route of node.children) {
                const tripPattern = route.children?.find(x => x.label == name);
                if (tripPattern) {
                    return tripPattern;
                }
            }
        }
    }
}

export const getCheckpointTree = (nodes: TreeDto[], name: string) => {
    for (const routeGroup of nodes) {
        if (routeGroup.children) {
            for (const route of routeGroup.children) {
                if (route.children) {
                    for (const tripPattern of route.children) {
                        const checkpoint = tripPattern.children?.find(x => x.label == name);
                        if (checkpoint) {
                            return checkpoint;
                        }
                    }
                }
            }
        }
    }
}

export const getActiveRoutes = (nodes: TreeDto[], type: string) => {
    const routes: TreeDto[] = [];
    for (const node of nodes) {
        if (node.children) {
            const routeTrees = node.children.filter(x =>
                (type == 'route') ? x.is_active_route == true : x.is_active_checkpoint == true
            );

            if (routeTrees.length > 0) {
                routeTrees.map(x => routes.push(x));
            }
        }
    }

    return routes;
}

export const getActiveTripPatterns = (nodes: TreeDto[], type: string) => {
    const tripPatterns: TreeDto[] = [];
    for (const node of nodes) {
        if (node.children) {
            for (const route of node.children) {
                if (route.children) {
                    const tripPatternsTree = route.children.filter(x =>
                        (type == 'route') ? x.is_active_route == true : x.is_active_checkpoint == true
                    );

                    if (tripPatternsTree.length > 0) {
                        tripPatternsTree.map(x => tripPatterns.push(x));
                    }
                }
            }
        }
    }
    return tripPatterns;
}

export const getActiveCheckpoints = (nodes: TreeDto[], type: string) => {
    const checkpoints: TreeDto[] = [];
    for (const routeGroup of nodes) {
        if (routeGroup.children) {
            for (const route of routeGroup.children) {
                if (route.children) {
                    for (const tripPattern of route.children) {
                        if (tripPattern.children) {
                            const checkpointsTree = tripPattern.children.filter(x =>
                                (type == 'route') ? x.is_active_route == true : x.is_active_checkpoint == true
                            );

                            if (checkpointsTree.length > 0) {
                                checkpointsTree.map(x => checkpoints.push(x));
                            }
                        }
                    }
                }
            }
        }
    }

    return checkpoints;
}
